import { configureStore } from '@reduxjs/toolkit'
import authSlice from '@/store/slices/authSlice'
import chatSlice from '@/store/slices/chatSlice'
import hrChatSlice from '@/store/slices/hrChatSlice'
import opsChatSlice from '@/store/slices/opsChatSlice'
import themeSlice from '@/store/slices/themeSlice'
import socketSlice from '@/store/slices/socketSlice'
import glossarySlice from '@/store/slices/glossarySlice'
import workAuthSlice from '@/store/slices/workAuthSlice'
import notificationTemplateSlice from '@/store/slices/notificationTemplateSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    chat: chatSlice,
    hrChat: hrChatSlice,
    opsChat: opsChatSlice,
    theme: themeSlice,
    socket: socketSlice,
    glossary: glossarySlice,
    workAuth: workAuthSlice,
    notificationTemplates: notificationTemplateSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
        ignoredPaths: ['socket.activeStreams', 'socket.joinedSessions'],
        ignoredActionsPaths: ['payload.timestamp'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch 